import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateDeleteExportTask } from '../../models/useMutateDeleteExportTask'

/**
 * Hook-only presenter (ADR-2): standard-confirmation delete with no
 * custom UI. The danger ConfirmationModal is owned by the
 * ReportExportHistoryView Feature Set; this hook executes the delete
 * command and surfaces the success/error toasts (BHV-037, ADR-10).
 */
export const useDeleteExportTaskPresenter = () => {
  const intl = useProcurifyIntl()

  const { deleteExportTask, isLoading } = useMutateDeleteExportTask()

  // Command behavior: surface feedback but don't throw to callers — the
  // FS confirm handler awaits and closes regardless of the outcome.
  const deleteExportTaskCommand = async (uuid: string): Promise<void> => {
    try {
      await deleteExportTask(uuid)

      toast.success({
        title: intl.formatMessage(messages.successToastTitle),
        children: intl.formatMessage(messages.successToastMessage),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.errorToastFallbackMessage),
      })
    }
  }

  return {
    commands: {
      deleteExportTask: deleteExportTaskCommand,
    },
    states: {
      isDeleting: isLoading,
    },
  }
}
